module.exports = __webpack_public_path__ + "img/我能购买人才公寓吗.1718209d.png";